import isBot from 'isbot';
import Vue from 'vue';

export default function splashAccepted(to, from, next) {
    const splashNeeded = (to.meta.splash !== false && !isBot(navigator.userAgent));
    const splashAccepted = localStorage.getItem('splashAccepted') || false;

    let config;

    if (splashAccepted) {
        if (to.meta.splash === false) {
            config = { name: 'home', query: to.query };
        }
    } else if (splashNeeded) {
        window.splashRedirectIntended = to.fullPath;
        config = { name: 'splash' };
    }

    if (config) {
        next(config); // redirect
    } else {
        next(); // explicitly allow navigation
    }
}